<script setup lang="ts">
import redBadgeImg from '@/assets/components/loggedBox/badge_red.webp?url'
import IconBoughtOffer from '@/assets/components/loggedBox/icon_check.png?url'

// const props =
defineProps<Props>()

interface Props {
  offer: Games.Offer | null
  showGameLogo?: boolean
  discountRibbonSize?: Partial<Record<'big' | 'medium' | 'mini' | 'miniGems', boolean>>
  ratio?: number
}
const { games } = siteUtils
const { t } = useI18n()
const isTranslatedValueString = false
</script>

<template>
  <div
    v-if="offer?.id"
    class="box-hover-effect-desktop text-left"
  >
    <div
      class="border rounded-xl shadow-standard hover:shadow-xl bg-white relative p-1.5 pb-0 h-full"
      :class="{
        'opacity-20': (offer?.expireSec || 0) < 0
      }"
    >
      <div
        class="flex flex-col h-full justify-between"
      >
        <!-- name -->
        <div
          class="min-h-7 pb-1"
        >
          <div class="flex flex-col justify-center">
            <div class="tracking-wide text-center px-2 text-black">
              <div
                class="font-black text-base line-clamp-1 whitespace-pre-line leading-tight pb-1 uppercase"
              >
                {{ t('offerTile.exclusiveOffer') }}
              </div>
            </div>
          </div>
        </div>
        <!-- main img & items & gameLogo & boughtMark -->
        <div class="relative">
          <!-- main img -->
          <div
            class="relative overflow-hidden rounded-lg"
            :style="`padding-top: ${ratio || 55}%`"
          >
            <div
              class="absolute inset-0 bg-cover bg-no-repeat bg-top bg-black"
              :style="{ backgroundImage: `url('${offer?.asset}')` }"
              :class="{ grayscale: offer?.isBought }"
            />
            <!-- boughtMark -->
            <template v-if="offer?.isBought">
              <div
                class="absolute inset-0 bg-black/50"
              />
              <div
                class="absolute w-full top-[20%] flex flex-col justify-center items-center"
              >
                <img
                  alt="already bought"
                  class="w-1/5"
                  :src="IconBoughtOffer"
                >
                <div class="text-white text-sm text-center pt-1.5">
                  {{ t('offerTile.alreadyBought') }}
                </div>
              </div>
            </template>
          </div>
          <!-- gameLogo -->
          <div
            v-if="showGameLogo && games[offer.gameKey]?.logo"
            class="absolute top-3 right-1"
          >
            <img
              :src="games?.[offer?.gameKey]?.logo"
              alt="logo"
              class="w-28"
            >
          </div>
          <!-- items -->
          <goat-page-home-offer-tile-items-block-component
            :offer="offer"
            :class="{ grayscale: offer?.isBought }"
          />
        </div>
        <!-- buyBtn -->
        <div
          class="text-right flex flex-col mt-10 mb-2"
          :class="{ grayscale: offer?.isBought }"
        >
          <div class="text-center inline-block">
            <slot name="button" />
          </div>
        </div>
      </div>
      <div
        v-if="offer?.purchaseLimit && offer.purchaseLimit < 1000"
        class="text-xs text-neutral-400 pt-1 absolute bottom-1 left-0 right-0 text-center"
      >
        {{ t('offerTile.limit') }} <b>{{ offer?.purchaseLimit }}</b> {{ t('offerTile.pcs') }}
      </div>
      <div
        v-if="!!offer?.extraValueInfo"
        class="bg-contain bg-no-repeat absolute top-0 right-0 -translate-y-px aspect-217/313 min-w-16 text-white text-center"
        :class="{ grayscale: offer?.isBought }"
        :style="`background-image: url('${redBadgeImg}'); --tile-badge-font-size: ${(4 / offer.extraValueInfo.length) * (Math.max(offer.extraValueInfo.length, 4) / 4)}rem ;`"
      >
        <div
          class="flex flex-col justify-end px-2 h-full leading-none"
          :class="{
            'pb-4': offer.extraValueInfo !== 'FREE',
            'pb-6': offer.extraValueInfo === 'FREE'
          }"
        >
          <div
            class="font-black"
            :style="{
              fontSize: 'calc(var(--tile-badge-font-size) * 1.15)'
            }"
          >
            {{ offer.extraValueInfo }}
          </div>
          <div
            v-if="offer.extraValueInfo !== 'FREE'"
            class="uppercase font-bold"
            :style="{
              fontSize: 'Max(calc(var(--tile-badge-font-size) * 0.6), 0.8rem)'
            }"
          >
            {{ isTranslatedValueString ? t('offerTile.value') : 'VALUE' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">

</style>
